export default class {
    constructor(Component) {
        this.Component = Component;
        this.initial = this.container.innerHTML;
    }
    set     container(content) { this.container.innerHTML = content }
    get     container() { return this.Component.instance.querySelector('.buttons-container') }
    async   render(page) { this.container = (page.buttons ?? []).join('') }
}
